module.exports = __webpack_public_path__ + "static/media/tuer_richtig.cac608ad.jpg";